import _implicitStylesheets from "./alert.css";
import _implicitScopedStylesheets from "./alert.scoped.css?scoped=true";
import _axToast from "ax/toast";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  "alert": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, b: api_bind, c: api_custom_element, h: api_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.classes),
    key: 0
  }, [api_custom_element("ax-toast", _axToast, {
    classMap: stc0,
    props: {
      "ariaLabel": $cmp.ariaLabel,
      "ariaLive": $cmp.ariaLive,
      "theme": $cmp.theme,
      "toastTitle": $cmp.alertTitle,
      "toastMessage": $cmp.alertMessage,
      "toastAction": $cmp.alertAction,
      "toastActionMessage": $cmp.alertActionMessage
    },
    key: 1,
    on: {
      "toastaction": _m0 || ($ctx._m0 = api_bind($cmp.handleToastAction)),
      "close": _m1 || ($ctx._m1 = api_bind($cmp.handleToastClose))
    }
  })])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4r9948qqhg7";
tmpl.legacyStylesheetToken = "ax-alert_alert";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
